/**
 * @generated SignedSource<<a6df2dd178403972c8f6ca8ca68f3ddc>>
 * @relayHash 80aca4d969021cf77b5bc002aaf13b3d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 88feb42ba564fe71f0c2ebeab117efd3fdbe222848561243583c52fb5944b1cb

var node = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "containerId"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "containerType"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "contentId"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "contentType"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "emojiId"
    }],
    v1 = [{
      "args": [{
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }, {
        "kind": "Variable",
        "name": "containerId",
        "variableName": "containerId"
      }, {
        "kind": "Variable",
        "name": "containerType",
        "variableName": "containerType"
      }, {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      }, {
        "kind": "Variable",
        "name": "contentType",
        "variableName": "contentType"
      }, {
        "kind": "Variable",
        "name": "emojiId",
        "variableName": "emojiId"
      }],
      "concreteType": "SaveReactionResponse",
      "kind": "LinkedField",
      "name": "addReaction",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "name": "ari"
      }, {
        "kind": "ScalarField",
        "name": "containerAri"
      }, {
        "kind": "ScalarField",
        "name": "emojiId"
      }]
    }];
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "name": "mainAddReactionMutation",
      "selections": v1 /*: any*/,
      "type": "Mutation"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "mainAddReactionMutation",
      "selections": v1 /*: any*/
    },
    "params": {
      "id": "88feb42ba564fe71f0c2ebeab117efd3fdbe222848561243583c52fb5944b1cb",
      "metadata": {},
      "name": "mainAddReactionMutation",
      "operationKind": "mutation",
      "text": null
    }
  };
}();
node.hash = "3165e43b2c229c24b56bdd89a7db74ac";
export default node;